module.exports = __webpack_public_path__ + "static/media/koerber-pharma-software.01bb0b58.jpg";